// extracted by mini-css-extract-plugin
module.exports = {"join_in":"jonin_join_in__-hQqd","agreement_box":"jonin_agreement_box__1zNO3","agreement_modal":"jonin_agreement_modal__40xRa","Add_tags":"jonin_Add_tags__d85Z7"};